import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export class FileInfoPanelFeature extends BaseTitleBarFeature {
    public show() {
        this.getAppServices().viewableServiceLayer.extensionService?.getCallBackAdapter()?.onFileInfoClick?.();
    }

    public showDocSizePanel() {
        this.getAppServices().viewableServiceLayer.extensionService?.getCallBackAdapter()?.onDocSizeClick?.();
    }
}
